import {
  IProductOffer,
  IProductPrice,
  IProductWeights,
} from '@/storePinia/interfaces/IProduct/IProduct';

interface IProductPayload {
  id?: string | number;
  price?: IProductPrice;
  offer?: IProductOffer;
  weights?: IProductWeights;
  isProductWithCustomWeight?: boolean;
  isProductWithoutNominal?: boolean;
}

interface IGetBuyPayloadReturn {
  id: string | number;
  count: number;

  isProductWithoutNominal?: boolean;
  price?: number | string;
  isProductWithCustomWeight?: boolean;
  weightOption?: string;
  weight?: string;
  barcode?: string;
}

export function getBuyPayload<T extends IProductPayload>(product: T): IGetBuyPayloadReturn {
  const payload: IGetBuyPayloadReturn = {
    id: product.offer?.id || product.id || '',
    count: product.price?.quantity || 1,
    // price має бути завжди для покупки в один клік.
    price: product.price?.price,
  };

  // for product with nominal
  if (product.isProductWithoutNominal) {
    payload.isProductWithoutNominal = true;
  }

  // for product with custom weight
  if (product?.isProductWithCustomWeight) {
    payload.isProductWithCustomWeight = true;

    const activeWeight = product.weights?.items?.find((item) => item.active);

    payload.price = activeWeight?.dbPrice;
    payload.weightOption = activeWeight?.weightOption;
    payload.weight = activeWeight?.weight;
    payload.barcode = activeWeight?.barcode;
  }

  return payload;
}
